export default __webpack_public_path__ + "static/media/TonicWinners.fd9da653b930557533fafd7e8fdc87a0.webp";